// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"bc57313e","655":"bc57313e"}[chunkId] + ".chunk.css";
};